import { render, staticRenderFns } from "./OfertasValidarSingle.vue?vue&type=template&id=740e6c28&scoped=true&lang=pug"
import script from "./OfertasValidarSingle.vue?vue&type=script&lang=js"
export * from "./OfertasValidarSingle.vue?vue&type=script&lang=js"
import style0 from "./OfertasValidarSingle.vue?vue&type=style&index=0&id=740e6c28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740e6c28",
  null
  
)

export default component.exports